var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5980_9785",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 16,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.18827 1.84021C7.72942 2.23293 8 2.61538 8 2.61538C8 2.61538 8.27058 2.23293 8.81173 1.84021C9.38275 1.42582 10.255 1 11.4286 1C14.2857 1 16 3.15385 16 5.30771C16 10.6923 8 15 8 15C8 15 0 10.6923 0 5.30771C0 3.15385 1.71429 1 4.57143 1C5.74497 1 6.61725 1.42582 7.18827 1.84021ZM8 13.7347C8.17033 13.6312 8.37317 13.5046 8.60064 13.3566C9.31943 12.8889 10.2734 12.2143 11.2223 11.3839C13.1798 9.67118 14.8571 7.52178 14.8571 5.30771C14.8571 3.65849 13.563 2.07692 11.4286 2.07692C10.5891 2.07692 9.96666 2.36971 9.54286 2.66923C9.32924 2.8202 9.17042 2.97037 9.06847 3.07845C9.01788 3.13207 8.98254 3.17402 8.96264 3.19864C8.95272 3.2109 8.94676 3.21871 8.94477 3.22135L8.94711 3.2181L8.94882 3.2157L8.94982 3.2143C8.73779 3.51342 8.38178 3.69231 8 3.69231C7.62151 3.69231 7.26783 3.51576 7.05517 3.22127C7.05312 3.21856 7.04718 3.21078 7.03736 3.19864C7.01746 3.17402 6.98212 3.13207 6.93153 3.07845C6.82958 2.97037 6.67076 2.8202 6.45714 2.66923C6.03334 2.36971 5.41086 2.07692 4.57143 2.07692C2.43704 2.07692 1.14286 3.65849 1.14286 5.30771C1.14286 7.52178 2.82024 9.67118 4.77766 11.3839C5.72664 12.2143 6.68057 12.8889 7.39936 13.3566C7.62683 13.5046 7.82967 13.6312 8 13.7347Z",
    fill: "#000001"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5980_9785)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#131619"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartOutlined);
export default __webpack_public_path__ + "static/media/heart-outlined.8c1c19b267b453070b4556265a5c12f2.svg";
export { ForwardRef as ReactComponent };